import { render, staticRenderFns } from "./RetailBox.vue?vue&type=template&id=58d02826&scoped=true"
import script from "./RetailBox.vue?vue&type=script&lang=js"
export * from "./RetailBox.vue?vue&type=script&lang=js"
import style0 from "./RetailBox.vue?vue&type=style&index=0&id=58d02826&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d02826",
  null
  
)

export default component.exports